import { callAPi } from './http-common';

const add = (data) => {
  return callAPi.post('/seo/addParCategorytoSeo', data);
};
const get = () => {
  return callAPi.get('/seo/getAllParCate');
};
const getbyid = (id) => {
  return callAPi.get(`/seo/getParCate/${id}`);
};
const update = (id, data) => {
  return callAPi.patch(`/seo/updateParCate/${id}`, data);
};
const deletes = (id) => {
  return callAPi.delete(`/seo/deleteParCate/${id}`);
};
const ParentCategorySEO = {
  add,
  get,
  update,
  deletes,
  getbyid,
};

export default ParentCategorySEO;